var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3Disabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.729,
    height: 36.729,
    viewBox: "0 0 36.729 36.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step_3_off",
    "data-name": "step 3 off",
    transform: "translate(-96.25 -26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38461",
    "data-name": "Path 38461",
    d: "M114.615,26.25a18.365,18.365,0,1,0,18.365,18.365A18.385,18.385,0,0,0,114.615,26.25Zm0,34.689a16.324,16.324,0,1,1,16.324-16.324A16.344,16.344,0,0,1,114.615,60.939Z",
    transform: "translate(0)",
    fill: "#a3a9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38462",
    "data-name": "Path 38462",
    d: "M247.18,209.023l-4.381-4.381-1.442,1.442,5.1,5.1a1.02,1.02,0,0,0,1.442,0l10.2-10.2-1.442-1.442Z",
    transform: "translate(-134.605 -160.749)",
    fill: "#a3a9b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Disabled);
export default __webpack_public_path__ + "static/media/step3-disabled.97fd1bcb2c095657999fa07ca2194fa0.svg";
export { ForwardRef as ReactComponent };